import { setupDemoAuth } from "../../demo/demoAuth";
import { Dispatch } from "redux";
import authService from "../../services/authServices";
import { getProfiles, getUserPermissions } from "./permissions";
import { ActionType, IAction } from "./actionTypes";
import { RootState } from "../store";
import { Values } from "../../components/auth/LoginForm";

const signInSuccess = (): IAction => ({
  type: ActionType.SIGN_IN_SUCCESS,
});

const signInFailure = (): IAction => ({
  type: ActionType.SIGN_IN_FAILURE,
});

const signOutSuccess = (): IAction => ({
  type: ActionType.SIGN_OUT_SUCCESS,
});

const signOutFailure = (): IAction => ({
  type: ActionType.SIGN_OUT_FAILURE,
});

const destroySession = (): IAction => ({
  type: ActionType.DESTROY_SESSION,
});

const getInitData = () => async (dispatch: Dispatch<any>) => {
  await dispatch(getUserPermissions());
  await dispatch(getProfiles());
};

export const signIn = (_auth: Values) => async (dispatch: Dispatch<any>) => {
  setupDemoAuth();
  authService.setToken(localStorage.getItem("token") || "");
  dispatch(signInSuccess());
  dispatch(getInitData());
  authService.keepSession();
  return Promise.resolve("ok");
};

export const changePassword = (_auth: any) => async (dispatch: Dispatch<any>) => {
  signOut();
  return {};
};

export const signOut =
  () => (dispatch: Dispatch<any>) =>
    new Promise<string>(async (resolve) => {
      await authService.logout("");
      authService.revokeToken();
      setupDemoAuth();
      dispatch(signOutSuccess());
      dispatch(destroySession());
      dispatch(signInSuccess());
      resolve("ok");
    });

export const authorize = () => (dispatch: Dispatch<any>, getState: () => RootState) => {
  setupDemoAuth();
  authService.setToken(localStorage.getItem("token") || "");
  authService.keepSession();

  const { isAuth } = getState().auth;
  if (!isAuth) {
    dispatch(signInSuccess());
    dispatch(getInitData());
  }
};

export const remindPassword = async (_email?: string) => ({});

export const resetPassword = async (
  _userId?: string,
  _token?: string,
  _newPassword?: string
) => ({});
